import GetInboxRuleRequest from 'owa-service/lib/contract/GetInboxRuleRequest';
import GetInboxRuleResponse from 'owa-service/lib/contract/GetInboxRuleResponse';
import getInboxRuleRequest from 'owa-service/lib/factory/getInboxRuleRequest';
import getInboxRuleOperation from 'owa-service/lib/operation/getInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Helper method that creates the GetInboxRuleRequest body
 * @return GetInboxRuleRequest
 */
function createRequestBody(): GetInboxRuleRequest {
    return getInboxRuleRequest({ Header: getJsonRequestHeader() });
}

/**
 * Get inbox rules service
 * @return the GetInboxRuleResponse
 */
export default function getInboxRulesService(): Promise<GetInboxRuleResponse> {
    let requestBody = createRequestBody();
    return getInboxRuleOperation(requestBody);
}
